import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/inventories/parent-new/loading';

export const Route = createFileRoute('/_private/inventory/parent-new')({
  pendingComponent: Loading,
});
